import React, { useEffect, useState } from 'react'
import i18n from 'simple-react-i18n'
import { Box, Grid2, Typography } from '@mui/material'
import { MAIN_RADIUS } from 'utils/constants/Theme'
import { PASTEL_COLOR } from 'utils/constants/ColorTheme'
import { useDispatch } from 'react-redux'
import { PATH_PGSSE } from 'home/constants/RouteConstants'
import { useParams } from 'react-router'
import { push } from '@lagunovsky/redux-react-router'
import { getI18nTitleDataLength } from 'utils/StringUtil'
import PgsseAction from 'pgsse/action/PgsseAction'

const RATIO = 3

const Breadcrumb = ({
}) => {
    const dispatch = useDispatch()

    const { idDiagnostic } = useParams()

    const [steps, setSteps] = useState([])

    const onClickStep = step => dispatch(push(`${PATH_PGSSE}/phase${step}/${idDiagnostic}`))

    const formatLine = (i, nbElements, singular, plural, activateOnClick = true) =>
        ({ label: `${i18n.phase} ${i} : ${nbElements} ${getI18nTitleDataLength(singular, plural, nbElements)}`, color: nbElements ? PASTEL_COLOR.green : PASTEL_COLOR.orange, onClick: () => activateOnClick && onClickStep(i) })

    useEffect(() => {
        PgsseAction.fetchBreadcrumbStats(idDiagnostic).then(json => {
            setSteps(
                json.map((ind, i) => {
                    const phase = i + 1
                    switch (phase) {
                        case 1: return formatLine(phase, ind, i18n.diagnostic, i18n.diagnostics)
                        case 2: return formatLine(phase, ind, i18n.danger, i18n.dangers)
                        case 3: return formatLine(phase, ind, i18n.action, i18n.actions, false) // todo remove false when phase 3 dev
                        default: return formatLine(phase, ind, i18n.indicator, i18n.indicators, false) // todo remove false when phase 4 dev
                    }
                }),
            )
        })
    }, [idDiagnostic])

    return (
        <Grid2 container alignItems='center' >
            {steps.map((step, index) => (
                <Grid2
                    size={3}
                    key={index}
                    textAlign='center'
                    onClick={step.onClick}
                    sx={{
                        cursor: step.onClick && 'pointer',
                    }}
                >
                    <Box
                        key={index}
                        sx={{
                            borderRadius: index === 0 && MAIN_RADIUS,
                            position: 'relative',
                            padding: '0.5rem 1rem',
                            bgcolor: step.color,
                            color: '#fff',
                            clipPath: index === 0
                                ? `polygon(0 0, ${100 - RATIO}% 0, 100% 50%, ${100 - RATIO}% 100%, 0% 100%)`
                                : `polygon(0 0, ${100 - RATIO}% 0, 100% 50%, ${100 - RATIO}% 100%, 0 100%, ${RATIO}% 50%)`,
                        }}
                    >
                        <Typography variant='body2' fontWeight={'bold'}>
                            {step.label}
                        </Typography>
                    </Box>
                </Grid2>
            ),
            )}
        </Grid2>
    )
}

Breadcrumb.propTypes = {
}


export default Breadcrumb